import { UserDropdownItem } from 'components/Layouts/Headers/HeaderComponents/UserDropdown/UserDropdown.typed';
import { USER_MENU } from 'components/Layouts/components/UserMenu';
import {
  CardOutlineIc,
  ChatboxOutlineIc,
  CreateOutlineIc,
  HeartOutlineIc,
  PersonCircleOutlineIc,
  StarOutlineIc,
  TimeOutlineIc,
} from '@dsch/dd-icons';
import { theme } from 'helpers/Theme';
import * as UserDropdownStyles from 'components/Layouts/Headers/HeaderComponents/UserDropdown/UserDropdown.styled';
import getConfig from 'next/config';

const {
  publicRuntimeConfig: { CDN_STATIC_ASSETS },
} = getConfig();

export const getMenuItems = (
  selected?: USER_MENU,
  historyChecks?: number,
  messages?: number,
  showMore?: boolean,
): UserDropdownItem[] => {
  return [
    {
      id: USER_MENU.MY_DONE_DEAL,
      selected: selected === USER_MENU.MY_DONE_DEAL,
      displayName: 'Profile',
      link: `/dashboard/${USER_MENU.MY_DONE_DEAL}`,
      icon: (
        <PersonCircleOutlineIc
          color={theme.colors.GREY_DARKER}
          width="20"
          height="20"
        />
      ),
      itemHidden: false,
    },
    {
      id: USER_MENU.MY_ADS,
      selected: selected === USER_MENU.MY_ADS,
      displayName: 'My Ads',
      link: `/dashboard/${USER_MENU.MY_ADS}`,
      icon: (
        <CreateOutlineIc
          color={theme.colors.GREY_DARKER}
          width="20"
          height="20"
        />
      ),
      itemHidden: false,
    },
    {
      id: USER_MENU.MESSAGES,
      selected: selected === USER_MENU.MESSAGES,
      displayName: 'Messages',
      link: `/accounts/classifieds/${USER_MENU.MESSAGES}`,
      notifications: messages && messages > 0 ? messages : null,
      icon: (
        <ChatboxOutlineIc
          color={theme.colors.GREY_DARKER}
          width="20"
          height="20"
        />
      ),
      itemHidden: false,
    },
    {
      id: USER_MENU.SAVED,
      selected: selected === USER_MENU.SAVED,
      displayName: 'Saved ads',
      link: `/dashboard/${USER_MENU.SAVED}`,
      icon: (
        <HeartOutlineIc
          color={theme.colors.GREY_DARKER}
          width="20"
          height="20"
        />
      ),
      itemHidden: false,
    },
    {
      id: USER_MENU.SEARCHES,
      selected: selected === USER_MENU.SEARCHES,
      displayName: 'Saved searches',
      link: `/dashboard/${USER_MENU.SEARCHES}`,
      icon: (
        <StarOutlineIc
          color={theme.colors.GREY_DARKER}
          width="20"
          height="20"
        />
      ),
      itemHidden: false,
    },
    {
      id: USER_MENU.BROWSING_HISTORY,
      selected: selected === USER_MENU.BROWSING_HISTORY,
      displayName: 'Browsing History',
      link: `/dashboard/${USER_MENU.BROWSING_HISTORY}`,
      icon: (
        <TimeOutlineIc
          color={theme.colors.GREY_DARKER}
          width="20"
          height="20"
        />
      ),
      itemHidden: !showMore,
    },
    {
      id: USER_MENU.HISTORY_CHECKS,
      selected: selected === USER_MENU.HISTORY_CHECKS,
      displayName: 'History checks',
      link: `/dashboard/${USER_MENU.HISTORY_CHECKS}`,
      notifications: historyChecks && historyChecks > 0 ? historyChecks : null,
      icon: (
        <UserDropdownStyles.HistoryCheckIcon
          src={`${CDN_STATIC_ASSETS}/images/illustrations/greenlight-dark.svg`}
          width="20"
          height="20"
        />
      ),
      itemHidden: !showMore,
    },
    {
      id: USER_MENU.PAYMENTS,
      selected: selected === USER_MENU.PAYMENTS,
      displayName: 'Payment history',
      link: `/dashboard/${USER_MENU.PAYMENTS}`,
      icon: (
        <CardOutlineIc
          color={theme.colors.GREY_DARKER}
          width="20"
          height="20"
        />
      ),
      itemHidden: !showMore,
    },
  ];
};
